<template>
  <div>
    <el-form
      :validate-on-rule-change="false"
      label-width="100px"
      label-position="left"
    >
      <el-form-item label="选择模型">
        <el-cascader
          v-model="configureModelComputed"
          :options="resourceOptionsModel"
          :props="{
            label: 'title',
            multiple: true,
            emitPath: false,
          }"
          multiple
          clearable
          collapse-tags
          leaf="modelColor"
          :show-all-levels="false"
          @change="selectModel"
          style="width: 99%"
        ></el-cascader>
      </el-form-item>
      <el-table
        :data="dyeingSelectModel"
        class="dyeingTable"
        border
        height="490"
        style="width: 99%"
      >
        <el-table-column prop="name" :show-overflow-tooltip="true" label="模型">
          <template slot-scope="scope" style="width: 100%">
            {{
              scope.row.name
                ? scope.row.name
                : recursiveFindName(resourceOptionsModel, scope.row.id).bimModel
                    .modelName
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="opacity"
          :show-overflow-tooltip="true"
          label="透明度"
          width="200px"
        >
          <template slot-scope="scope" style="width: 100%">
            <el-input
              v-model="scope.row.opacity"
              type="number"
              min="0"
              max="1"
              step="0.1"
              placeholder="请输入透明度"
              @input="
                (e) => {
                  opacityInput(e, scope.row);
                }
              "
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="color"
          :show-overflow-tooltip="true"
          label="颜色"
        >
          <template slot-scope="scope" style="width: 100%">
            <el-color-picker
              v-model="scope.row.color"
              @change="
                (e) => {
                  colorChange(e, scope.row);
                }
              "
              show-alpha
              :predefine="predefineColors"
            ></el-color-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="opacity"
          :show-overflow-tooltip="true"
          label="是否着色"
          width="200px"
        >
          <template slot-scope="scope" style="width: 100%">
            <!-- {{ scope.row.color }} -->
            <el-switch
              v-model="scope.row.switch"
              @change="
                (e) => {
                  scopeChange(e, scope.row);
                }
              "
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "screenplay-dyeing",
  props: ["configureModel", "resourceOptionsModel", "DyeingList"],
  data() {
    return {
      dyeingSelectModel: this.DyeingList,
      configureModelComputed: this.configureModel,
      predefineColors: [
        //颜色选择器
        "#ffffff",
        "#c71585",
        "#ff4500",
        "#ffd700",
        "#55e8a2",
        "#1ba784",
        "#00ced1",
        "#1e90ff",
        "#9932cd",
        "#000000",
      ],
    };
  },
  model: {
    prop: "DyeingList",
  },
  methods: {
    rgbaNum(rgba, index) {
      let val = rgba.match(/(\d(\.\d+)?)+/g);
      return val[index];
    },
    // 选中模型
    selectModel(value) {
      this.configureModelComputed = value;
      // 清空
      if (value.length == 0) {
        this.dyeingSelectModel = [];
        this.$emit(
          "dyeingSelectChange",
          this.dyeingSelectModel,
          this.configureModelComputed
        );
        return;
      }
      // arr数组永远是最新的数据（除颜色以外）
      let arr = [];
      value.forEach((item) => {
        const obj = this.recursiveFindName(this.resourceOptionsModel, item);
        if (obj) {
          arr.push({
            id: item,
            name: obj.title,
            color: obj.bimModel.modelColor,
            opacity:
              obj.bimModel.modelColor && obj.bimModel.modelColor != ""
                ? this.rgbaNum(obj.bimModel.modelColor, 3)
                : 1,
            switch:
              obj.bimModel.modelColor && obj.bimModel.modelColor != ""
                ? true
                : false,
          });
        }
      });
      // 当前没有数据直接赋值
      if (this.dyeingSelectModel.length == 0) {
        this.dyeingSelectModel = arr;
        this.$emit(
          "dyeingSelectChange",
          this.dyeingSelectModel,
          this.configureModelComputed
        );
      } else {
        // 有数据找到重复的，赋值颜色
        arr.forEach((item) => {
          const obj = this.dyeingSelectModel.find((xtem) => item.id == xtem.id);
          if (obj) {
            item.opacity = obj.opacity;
            item.color = obj.color;
            item.switch = obj.switch;
          }
        });
        // 覆盖
        this.dyeingSelectModel = arr;
        this.$emit(
          "dyeingSelectChange",
          this.dyeingSelectModel,
          this.configureModelComputed
        );
      }
    },
    // 颜色修改
    colorChange(e, item) {
      let { color } = item;
      if (color) {
        item.opacity = this.rgbaNum(color, 3);
      }
      //
      this.$emit(
        "dyeingSelectChange",
        this.dyeingSelectModel,
        this.configureModelComputed
      );
    },
    scopeChange(e, item) {
      if ((item.color == null || item.color == "") && e) {
        item.color = `rgba(255, 255, 255, ${item.opacity})`;
      }
    },
    // 递归找名字
    recursiveFindName(data, id) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          return data[i];
        } else if (data[i]?.children?.length > 0) {
          if (this.recursiveFindName(data[i].children, id)) {
            return this.recursiveFindName(data[i].children, id);
          }
        }
      }
    },
    // 调整透明度
    opacityInput(e, item) {
      let { color } = item;
      if (color && color != "") {
        item.color = `rgba(${this.rgbaNum(color, 0)},${this.rgbaNum(
          color,
          1
        )},${this.rgbaNum(color, 2)},${e})`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dyeingTable {
  /deep/td:last-child {
    border-right: 0;
  }
  /deep/ .el-table__body-wrapper {
    &::-webkit-scrollbar {
      // 整个滚动条
      width: 0; // 纵向滚动条的宽度
      background: rgba(213, 215, 220, 0.3);
      border: none;
    }
    &::-webkit-scrollbar-track {
      // 滚动条轨道
      border: none;
    }
  }

  // --------------------隐藏table gutter列和内容区右侧的空白 start
  /deep/ .el-table th.gutter {
    display: none;
    width: 0;
  }
  /deep/ .el-table colgroup col[name="gutter"] {
    display: none;
    width: 0;
  }

  /deep/ .el-table__body {
    width: 100% !important;
    border-bottom: 1px solid #b0b0b0;
  }
  /deep/ .el-table__body {
    width: 100% !important;
    border-bottom: 1px solid #b0b0b0;
  }
  /deep/.el-table__row td {
    border-bottom: 1px solid #b0b0b0 !important;
  }
  /deep/.has-gutter th {
    border-bottom: 1px solid #b0b0b0 !important;
  }
}
</style>
